// extracted by mini-css-extract-plugin
export var container = "_3u-0";
export var icon = "_3u-1";
export var text = "_3u-2";